import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-crystal-charcoal via-crystal-charcoal/95 to-crystal-charcoal">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="mb-8">
          <Button variant="ghost" className="text-white/80 hover:text-white hover:bg-white/10 mb-6" asChild>
            <Link to="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <h1 className="text-4xl font-bold text-white mb-4">Privacy Policy</h1>
          <p className="text-white/60">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="glass-panel p-8 space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Introduction</h2>
            <p className="text-white/80 leading-relaxed">
              Crystal HACCP ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy 
              explains how we collect, use, disclose, and safeguard your information when you use our food safety 
              management platform and services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Information We Collect</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Account Information</h3>
                <p className="text-white/80">Name, email address, organization details, and authentication credentials.</p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Operational Data</h3>
                <p className="text-white/80">Checklist data, temperature logs, incident reports, and compliance records.</p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Usage Information</h3>
                <p className="text-white/80">Log data, device information, and analytics to improve our services.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">How We Use Your Information</h2>
            <ul className="text-white/80 space-y-2 list-disc list-inside">
              <li>Provide and maintain our HACCP compliance services</li>
              <li>Generate compliance reports and documentation</li>
              <li>Communicate about service updates and support</li>
              <li>Ensure data security and prevent fraud</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Data Sharing and Disclosure</h2>
            <p className="text-white/80 leading-relaxed mb-4">
              We do not sell, trade, or otherwise transfer your personal information to third parties except:
            </p>
            <ul className="text-white/80 space-y-2 list-disc list-inside">
              <li>With your explicit consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and safety</li>
              <li>With trusted service providers bound by confidentiality</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Data Security</h2>
            <p className="text-white/80 leading-relaxed">
              We implement industry-standard security measures including encryption, access controls, 
              and regular security assessments to protect your data from unauthorized access, alteration, 
              disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Your Rights</h2>
            <p className="text-white/80 leading-relaxed mb-4">
              Depending on your jurisdiction, you may have rights including:
            </p>
            <ul className="text-white/80 space-y-2 list-disc list-inside">
              <li>Access to your personal data</li>
              <li>Correction of inaccurate data</li>
              <li>Deletion of your data</li>
              <li>Data portability</li>
              <li>Objection to processing</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
            <p className="text-white/80 leading-relaxed">
              If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:privacy@themikanaohub.com" className="text-crystal-orange hover:text-crystal-orange-glow transition-colors">
                privacy@themikanaohub.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;